function product_view() {
  let view_val = Cookies.get("product-view");
  if (view_val !== undefined) {
    if (view_val === "product-grid-view") {
      jQuery(".product-view-btn.list-view").removeClass("active");
      jQuery(".product-view-btn.grid-view").addClass("active");
      jQuery(".product-view-mode .productGrid").removeClass(
        "product-list-view"
      );
      jQuery(".product-view-mode .productGrid").addClass(
        "product-grid-view product-grid-view"
      );
    } else {
      jQuery(".product-view-btn.grid-view").removeClass("active");
      jQuery(".product-view-btn.list-view").addClass("active");
      jQuery(".product-view-mode .productGrid").removeClass(
        "product-grid-view"
      );
      jQuery(".product-view-mode .productGrid").addClass(
        "product-list-view product-list-style"
      );
    }
  } else {
    jQuery(".product-view-btn.list-view").removeClass("active");
    jQuery(".product-view-btn.grid-view").addClass("active");
    jQuery(".product-view-mode .productGrid").removeClass("product-list-view");
    jQuery(".product-view-mode .productGrid").addClass(
      "product-grid-view product-grid-view"
    );
  }
}

jQuery(document).ready(function () {
  $(document).on("click", ".product-view-button a", (e) => {
    e.preventDefault();
    $(".product-view-button a").removeClass("active");
    let currentTarget = $(e.currentTarget).data("view-val");
    $(e.currentTarget).addClass("active");
    switch (currentTarget) {
      case "product-grid-view":
        $(".product-view-mode .productGrid").removeClass("product-list-style");
        $(".product-view-mode .productGrid").addClass(currentTarget);
        Cookies.set("product-view", currentTarget);
        break;
      case "product-list-style":
        $(".product-view-mode .productGrid").removeClass("product-grid-view");
        $(".product-view-mode .productGrid").addClass(currentTarget);
        Cookies.set("product-view", currentTarget);
        break;
      default:
    }
  });
  product_view();
});

$(document).ajaxStop(function () {
  product_view();
});
